import { useEffect } from "react";
import { useWorkspace } from "../contexts/WorkspaceContext";

export default function WorkspaceSwitcher() {
  const { workspaceId, selectWorkspace, workspaces, refreshWorkspaces } = useWorkspace();

  useEffect(() => {
    refreshWorkspaces();
  }, [refreshWorkspaces]);

  return (
    <select
      className="workspace-select"
      value={workspaceId || ""}
      onChange={(e) => {
        selectWorkspace(e.target.value);
      }}
    >
      <option value="">Select workspace</option>
      {workspaces.map((workspace) => (
        <option key={workspace.id} value={workspace.id}>
          {workspace.name}
        </option>
      ))}
    </select>
  );
}
